import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a147c98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-2" }
const _hoisted_2 = { class: "px-1" }
const _hoisted_3 = { class: "entry-content" }
const _hoisted_4 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SocialSharing = _resolveComponent("SocialSharing")!
  const _component_attribute_list = _resolveComponent("attribute-list")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_admin_link = _resolveComponent("admin-link")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("article", {
      class: _normalizeClass(["wdw-news-thought d-flex-column m-auto pt-1", 'thought-' + $props.thought.id])
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.backToList && $setup.backToList(...args))),
          class: "btn btn-primary"
        }, "zurück")
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_SocialSharing, {
          url: $setup.getCurrenThoughtUri($props.thought.id),
          title: $props.thought.title,
          description: $props.thought.content
        }, null, 8, ["url", "title", "description"]),
        _withDirectives(_createElementVNode("h2", null, null, 512), [
          [_directive_dompurify_html, $props.thought.title]
        ]),
        _createVNode(_component_attribute_list, {
          attributes: $props.thought.attributes
        }, null, 8, ["attributes"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: "calendar-days",
            class: "icon"
          }),
          _createElementVNode("span", _hoisted_2, _toDisplayString($setup.formattedDate($props.thought.publication_date, true)), 1)
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
        [_directive_dompurify_html, $props.thought.content]
      ]),
      _createVNode(_component_admin_link, {
        links: $props.thought.links
      }, null, 8, ["links"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.backToList && $setup.backToList(...args))),
          class: "btn btn-primary"
        }, "zurück")
      ])
    ], 2)
  ]))
}